import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { toast } from "sonner";
import AuthShell from "../components/AuthShell";
import { useAuth } from "../context/AuthContext";
import { formatApiError } from "../lib/api";

const inputCls =
  "w-full bg-panel border border-white/10 px-5 py-4 text-sm text-slate-100 placeholder:text-slate-600 focus:outline-none focus:border-volt/60 transition-colors duration-300";

export default function Login() {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setBusy(true);
    try {
      const user = await login(form.email, form.password);
      toast.success(`Welcome back, ${user.name}`);
      navigate("/dashboard");
    } catch (err) {
      setError(formatApiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthShell
      title="Access your portal"
      subtitle="Enter your credentials to continue."
      footer={<>No account yet? <a href="/#contact" data-testid="login-to-contact-link" className="text-volt hover:underline">Request access from the studio</a></>}
    >
      <form onSubmit={submit} className="space-y-5" data-testid="login-form">
        <input data-testid="login-email-input" type="email" required placeholder="Email address" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} className={inputCls} />
        <input data-testid="login-password-input" type="password" required placeholder="Password" value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} className={inputCls} />
        {error && <p data-testid="login-error" className="font-mono text-xs text-red-400 border border-red-500/30 bg-red-500/10 px-4 py-3">{error}</p>}
        <button data-testid="login-submit-btn" disabled={busy} className="w-full bg-volt text-obsidian font-mono text-xs uppercase tracking-[0.2em] font-bold px-8 py-4 hover:bg-[#CCEE00] transition-colors duration-300 disabled:opacity-50">
          {busy ? "Authenticating..." : "Enter Portal"}
        </button>
      </form>
    </AuthShell>
  );
}
